import {
	LOGIN_SUCCESS,
	LOGOUT_SUCCESS,
	GOOGLE_LOGIN_SUCCESS,
} from '../actions/types';

const initState = null;

const authUserReducer = (state = initState, action) => {
	switch (action.type) {
		case LOGIN_SUCCESS:
			return {
				...action.user,
			};
		case GOOGLE_LOGIN_SUCCESS:
			return {
				...state,
				uid: action.user.id,
				user: { ...action.user },
				authError: '',
			};
		case LOGOUT_SUCCESS:
			return null;
		default:
			return state;
	}
};

export default authUserReducer;
